import React from 'react';
import classNames from 'classnames';
import { Link } from 'react-router-dom';
import Router from 'src/navigation/router';
import { routes } from 'src/navigation';
import styles from '../../assets/student-main-tab.module.scss';
import InfoItem from 'src/components/InfoItem';
import { IStudent } from 'src/types/student';

export interface StateProps {
    programBooks: any;
}
export interface DispatchProps {}

export interface OwnProps {
    student: Partial<IStudent> | null;
    tab?: string;
}

export interface Props extends StateProps, DispatchProps, OwnProps {}
const StudentInfo: React.FunctionComponent<Props> = ({ programBooks, student }: Props) => {
    if (!student) {
        return null;
    }

    const previewProgramBooks = (data: any) =>
        data &&
        data?.data?.list &&
        data.data.list.map((item: any, i: number) => (
            <Link
                key={i + 'pgb'}
                to={Router.generate(routes.PROGRAM_BOOK_DETAIL, {
                    id: item.id,
                })}
                type={'button'}
                className={'btn btn-outline-info mr-2'}
                target={'_blank'}
            >
                Program Book id = {item.id}
            </Link>
        ));

    console.log(programBooks?.data?.list?.length, programBooks);

    return programBooks?.data?.list?.length ? (
        <div className={classNames(styles.infoWrap)}>
            <div className={classNames(styles.infoItems)}>
                <InfoItem title={'Program Books'} value={previewProgramBooks(programBooks)} />
            </div>
        </div>
    ) : (
        <div className={classNames(styles.infoWrap)}>
            <div className={classNames(styles.infoItems)}>No Program book has been created yet</div>
        </div>
    );
};

export default StudentInfo;
